var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isChainSupported } from '@tria-sdk/core';
import { checksumAddress } from '../utils/helper/checksum';
import { isValidAddress } from '../utils/helper/isValidAddress';
import { KeyringController } from './keyring.controller';
import { isTriaName } from '../utils/helper';
import { LiFi } from '@lifi/sdk';
import axios from 'axios';
import { lifiUrl } from '../utils/constants';
const routeOptions = {
    infiniteApproval: true,
    integrator: 'tria',
};
const lifi = new LiFi({
    defaultRouteOptions: routeOptions,
    integrator: 'tria',
});
// 1. Extending Keyring only for memStore for tempVault in embedded wallet case, and getSigner function
export class WalletController extends KeyringController {
    constructor({ baseUrl, walletType, selectedChainName, environment = 'mainnet' }) {
        super({ baseUrl, walletType, selectedChainName, environment });
        if (isChainSupported(selectedChainName))
            this.selectedChainName = selectedChainName;
    }
    getRoutes(fromChainId, fromAmount, fromTokenAddress, toChainId, toTokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const routesRequest = {
                    fromChainId,
                    fromAmount,
                    fromTokenAddress,
                    toChainId,
                    toTokenAddress,
                    options: routeOptions,
                };
                const result = yield lifi.getRoutes(routesRequest);
                console.log('result in sdk', result);
                const routes = result.routes;
                console.log('routes in sdk', routes);
                return routes;
            }
            catch (error) {
                console.error('Error not getting routes:', error);
                throw error;
            }
        });
    }
    getChains() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // chainTypes can be of type SVM and EVM; by default, only EVM chains will be returned
                const optionalChainTypes = "EVM";
                const result = yield axios.get(`${lifiUrl}/chains`, {
                    params: { chainTypes: optionalChainTypes },
                });
                return result.data;
            }
            catch (error) {
                console.error('Error calculating gas details:', error);
                throw error;
            }
        });
    }
    ;
    getTokens() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const tokens = yield axios.get(`${lifiUrl}/tokens`);
                return tokens.data;
            }
            catch (error) {
                console.error('Error calculating gas details:', error);
                throw error;
            }
        });
    }
    getTools() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield axios.get(`${lifiUrl}/tools`);
                return result.data;
            }
            catch (error) {
                console.error('Error calculating gas details:', error);
                throw error;
            }
        });
    }
    signMessage(message, chainName, privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { signer, chainInstance, triaName } = yield this.getSigner((this.selectedChainName || chainName), privateKey);
                console.log({ signer });
                // @ts-ignore
                const res = yield chainInstance.signMessage(signer, message);
                if (res) {
                    return { success: true, data: res };
                }
                else {
                    return { success: false, message: 'Error in signing message!' };
                }
            }
            catch (err) {
                console.error(err);
                return { success: false, message: err.message, error: err };
            }
        });
    }
    send(payload, chainName, privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (payload.amount <= 0)
                return { success: false, message: 'Invalid amount' };
            const chain = (this.selectedChainName || chainName);
            let { signer, chainInstance, triaName, address: fromAddress, } = yield this.getSigner(chain, privateKey);
            console.log({ payload });
            if (!fromAddress) {
                if (isTriaName(payload.fromTriaName))
                    fromAddress = yield this.resolveTriaName(payload.fromTriaName, chain);
                else if (isValidAddress(payload.fromTriaName))
                    fromAddress = payload.fromTriaName;
                else {
                    return { success: false, message: 'Invalid fromTriaName address.' };
                }
            }
            if (isChainSupported(chain)) {
                const { recipientTriaName } = payload;
                let recipientAddress;
                if (!recipientTriaName.includes('@tria') && isValidAddress(recipientTriaName))
                    recipientAddress = checksumAddress(payload.recipientTriaName);
                else
                    recipientAddress = yield this.resolveTriaName(payload.recipientTriaName, chain);
                const sendPayload = {
                    signer, // half shard // hex string
                    recipientAddress,
                    fromAddress,
                    amount: payload.amount,
                    tokenAddress: payload.tokenAddress,
                };
                const res = yield chainInstance.send(sendPayload);
                if (res.success)
                    yield this.userController.addUserActivity((triaName || payload.fromTriaName), recipientTriaName);
                return res;
            }
            else {
                return { success: false, message: 'Chain not supported.' };
            }
        });
    }
    approve(payload, chainName, privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const { amount, tokenAddress, spender } = payload;
            if (amount <= 0)
                return { success: false, message: 'Invalid amount' };
            const chain = (this.selectedChainName || chainName);
            const { signer, chainInstance, address: fromAddress } = yield this.getSigner(chain, privateKey);
            //@ts-ignore
            const res = yield (chainInstance === null || chainInstance === void 0 ? void 0 : chainInstance.approve({
                signer,
                fromAddress,
                tokenAddress,
                amount,
                spender,
            }));
            return res;
        });
    }
    swap(payload, chainName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (payload.fromAmount <= 0)
                return { success: false, message: 'Invalid amount' };
            const chain = (this.selectedChainName || chainName);
            const { signer, chainInstance, address: fromAddress } = yield this.getSigner(chain);
            const swapPayload = {
                signer, // privateKey shard
                fromAddress,
                fromTokenAddress: payload.fromTokenAddress,
                toTokenAddress: payload.toTokenAddress,
                amount: payload.fromAmount,
                slippage: payload.slippage || 1, // default 1%
            };
            // @ts-ignore
            const res = yield (chainInstance === null || chainInstance === void 0 ? void 0 : chainInstance.swap(swapPayload));
            return res;
            /** API call /swap (chainName, swapPayload) */
            // const tx = this.nonEVMService.swap("SHARD1", "CHAINAME", "PAYLOAD");
        });
    }
    sendNFT(recipientTriaName, nftDetails, chainName, privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (nftDetails.amount <= 0)
                return { success: false, message: 'Invalid amount' };
            const chain = (this.selectedChainName || chainName);
            const { signer, chainInstance, address: fromAddress, triaName, } = yield this.getSigner(chain, privateKey);
            if (isChainSupported(chain)) {
                let recipientAddress;
                if (!recipientTriaName.includes('@tria') && isValidAddress(recipientTriaName))
                    recipientAddress = checksumAddress(recipientTriaName);
                else
                    recipientAddress = yield this.resolveTriaName(recipientTriaName, chain);
                // @ts-ignore
                const res = yield (chainInstance === null || chainInstance === void 0 ? void 0 : chainInstance.sendNFT(signer, fromAddress, recipientAddress, nftDetails));
                if (res.success)
                    yield this.userController.addUserActivity(triaName, recipientTriaName);
                return res;
            }
            else {
                return { success: false, message: 'Chain not supported.' };
            }
        });
    }
    /**
     * Bali beta specific
     *
     */
    burnNFT(nftDetails, chainName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (nftDetails.amount <= 0)
                return { success: false, message: 'Invalid amount' };
            const chain = (this.selectedChainName || chainName);
            const { signer, chainInstance } = yield this.getSigner(chain);
            if (isChainSupported(chain)) {
                // @ts-ignore
                const res = yield (chainInstance === null || chainInstance === void 0 ? void 0 : chainInstance.burnNFT(signer, nftDetails));
                return res;
            }
            else {
                return { success: false, message: 'Chain not supported.' };
            }
        });
    }
    /**
     * Interact with any external contract
     * @param contractDetails
     * @param chainName
     * @returns
     */
    callContract(contractDetails, chainName, privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const chain = (this.selectedChainName || chainName);
            let { enableTriaName, args } = contractDetails;
            if (enableTriaName) {
                for (let i = 0; i < args.length; i++) {
                    if (isTriaName(args[i])) {
                        args[i] = yield this.resolveTriaName(args[i], chain);
                    }
                }
            }
            const { signer, chainInstance } = yield this.getSigner(chain, privateKey);
            if (isChainSupported(chain)) {
                // @ts-ignore
                const res = yield (chainInstance === null || chainInstance === void 0 ? void 0 : chainInstance.callContract(contractDetails, signer));
                return res;
            }
            else {
                return { success: false, message: 'Chain not supported.' };
            }
        });
    }
    /**
     * Not used right now
     * @param contractDetails
     * @param chainName
     * @returns
     */
    readContract(contractDetails, chainName) {
        return __awaiter(this, void 0, void 0, function* () {
            const chain = (this.selectedChainName || chainName);
            const chainInstance = this.chains[chain];
            if (isChainSupported(chain)) {
                // @ts-ignore
                const res = yield (chainInstance === null || chainInstance === void 0 ? void 0 : chainInstance.readContract(contractDetails));
                return res;
            }
            else {
                return { success: false, message: 'Chain not supported.' };
            }
        });
    }
    /**
     * Decrypt data with private key.
     * @param encryptedData
     * @param chainName
     * @returns
     */
    decrypt(encryptedData, chainName) {
        return __awaiter(this, void 0, void 0, function* () {
            const chain = (this.selectedChainName || chainName);
            const { signer, chainInstance, address, privateKey } = yield this.getSigner(chain);
            if (isChainSupported(chain)) {
                // @ts-ignore
                const res = yield (chainInstance === null || chainInstance === void 0 ? void 0 : chainInstance.decrypt(signer, encryptedData, address, privateKey));
                return res;
            }
            else {
                return { success: false, message: 'Chain not supported.' };
            }
        });
    }
    /**
     * Encrypt data with public key.
     * @param encryptedData
     * @param chainName
     * @returns
     */
    encrypt(data, version = 'x25519-xsalsa20-poly1305', chainName) {
        return __awaiter(this, void 0, void 0, function* () {
            const chain = (this.selectedChainName || chainName);
            const { signer, chainInstance, address, privateKey } = yield this.getSigner(chain);
            if (isChainSupported(chain)) {
                // @ts-ignore
                const res = yield (chainInstance === null || chainInstance === void 0 ? void 0 : chainInstance.encrypt(signer, data, address, version, privateKey));
                return res;
            }
            else {
                return { success: false, message: 'Chain not supported.' };
            }
        });
    }
}
